import packageJson from '../package.json';

export const appConstants = {
  ERROR_KEYS: {
    LOCK: 'avLockError',
  },
  AUTH_TOKEN_NAME: 'AUTHVIA_LOCK_TOKEN',
  SECURE_LINK_NAME: 'avLockSecureLink',
  REDIRECT_PATH_NAME: 'avLockRedirectPath',
  INITIAL_PATH_NAME: 'avLockInitialPath',
  SCOPED_MERCHANT_LINK_KEYS: {
    BUSINESS_PROCESS_ID: 'AUTHVIA_LOCK_SCOPED_BUSINESS_PROCESS_ID',
    MERCHANT_ID: 'AUTHVIA_LOCK_SCOPED_MERCHANT_ID',
  },
  /** One-shot: BP login from payment-method action; remount expands wallet list then clears. */
  OPEN_PAYMENT_METHOD_LIST_KEY: 'OpenPaymentMethodList',
  MERCHANT_LINK_JWT_CLAIM_KEYS: {
    BUSINESS_PROCESS: 'https://authvia.com/businessProcess',
  },
  DEFAULT_STYLING: {
    BORDER_RADIUS: '12px',
    PRIMARY_COLOR: '#36454F',
  },
  CURRENT_VERSION: packageJson.version,
  AV_PRIMARY_COLOR: '#4CAF50',
  AV_DEFAULT_LOGIN_BORDER_RADIUS: '6px',
  AV_ERROR_ICON_COLOR: '#f14668',
  AV_FORBIDDEN_ERROR_ICON_COLOR: '#151414',
  MERCHANT_DETAIL_PAGE_REDIRECT_TEXT: 'Redirecting to Business Processes Page',
};
